export default __webpack_public_path__ + "static/media/Bitmap_6.bc88a425.png";